import { useContext, useState } from "react"
import ApiContext from 'src/provider/API/call-service'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, AppLabel, AppSpan, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, Form, FormGroup, SidePopupContainer } from "src/style"
import helpers from "src/utils/helpers"


export const ErrorLogFilter: React.FC<any> = ({setFilterData, onApplyFilter, close}) => {
    const [input, setInput] = useState<any>({
        startDate: null, endDate: null
    })

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        await setFilterData(input)
        onApplyFilter()
        close()
    }
    
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FixedContainer 
                className="service-request-container" 
                zIndex="9" radius="0.8" bgColor="#ffffff"
                topPadding="1.5" height='40' hUnit='%' width="50"
            >
                <Form style={{height: '100%'}} onSubmit={handleSubmit}>
                    <CustomContainer 
                        height="85" hUnit="%" padding="2.5" overflow="auto" topPadding="1"
                    >
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel textSize="2" fontWeight="600">Filter By Date</AppLabel>
                            <AbsoluteContainer top="0" right="0" onClick={close}>
                                <RiCloseFill className='close-icon' />
                            </AbsoluteContainer>
                        </FlexRow>
                        <FormGroup bottomMargin="1.5">
                            <label>Start Date</label>
                            <input 
                                name='startDate'
                                type='date'
                                max={helpers.getInputValidDate()}
                                style={{color: input.startDate ? '#494949' : '#999'}}
                                value={input.startDate}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                        <FormGroup bottomMargin="1.5">
                            <label>End Date</label>
                            <input 
                                name='endDate'
                                type='date'
                                max={helpers.getInputValidDate()}
                                style={{color: input.endDate ? '#494949' : '#999'}}
                                value={input.endDate}
                                onChange={handleInput}
                                required
                            />
                        </FormGroup>
                    </CustomContainer>
                    <FlexColumn height="15" hUnit="%" justifyContent="flex-end">
                        <FlexRow justifyContent="flex-end" padding="2.5">
                            <Button
                                    width='8.1' borderColor='#E4ECF7' height='3.6'
                                    hoverBgColor='#E4ECF7' hoverColor='#505780'
                                    bgColor="#ffffff" color="#505780" rightMargin="1"
                                    radius="0.6" titleSize="1.2" type="button"
                                    onClick={close}
                                >
                                Cancel
                            </Button>
                            <Button
                                width='12.6' borderColor='#4C6FFF' height='3.6'
                                hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                radius="0.6" titleSize="1.2"
                            >
                                Apply Filter
                            </Button>
                        </FlexRow>
                    </FlexColumn>
                </Form>
            </FixedContainer>
        </>
    )
}